import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { DataGrid } from '@mui/x-data-grid'
import CloseButton from 'src/components/common/CloseButton'
import { convertToLocalCurrency } from 'src/utils/commonMethods/convertToLocalCurrency'
import {
  columns,
  columnsHealth,
  columnsMarine,
  FINANCIAL_PORTFOLIO_ANALYSIS_OVER,
  FINANCIAL_PREMIUM_CLAIMS_OVER,
  INSURANCE,
  PORTFOLIO_ANALYSIS_OVER,
  PREMIUM_CLAIMS_OVER,
} from 'src/utils/constants/RiskReports'

const MODAL_HEIGHT = 500

const DetailedView = ({
  closefunction,
  data,
  totalData,
  type,
  isFinancialView,
}) => {
  const classes = useStyles()

  const yearsText =
    type !== INSURANCE?.HEALTH ? PREMIUM_CLAIMS_OVER : PORTFOLIO_ANALYSIS_OVER

  const financialYearsText =
    type !== INSURANCE?.HEALTH
      ? FINANCIAL_PREMIUM_CLAIMS_OVER
      : FINANCIAL_PORTFOLIO_ANALYSIS_OVER

  const rows = data?.map((d, i) => ({
    ...d,
    id: i,
    claimsOutstanding: `₹ ${convertToLocalCurrency(d?.claimsOutstanding)}`,
    claimsPaid: `₹ ${convertToLocalCurrency(d?.claimsPaid)}`,
    totalClaims: `₹ ${convertToLocalCurrency(d?.totalClaims)}`,
    totalPremium: `₹ ${convertToLocalCurrency(d?.totalPremium)}`,
  }))

  const rowsMarine = data?.map((d, i) => ({
    ...d,
    id: i,
    turnOver: `₹ ${convertToLocalCurrency(d?.turnOver)}`,
    totalPremium: `₹ ${convertToLocalCurrency(d?.totalPremium)}`,
    totalClaims: `₹ ${convertToLocalCurrency(d?.totalClaims)}`,
    year: `${convertToLocalCurrency(d?.year)}`,
  }))

  const rowsHealth = data?.map((d, i) => ({
    ...d,
    id: i,
    claimSettled: `₹ ${convertToLocalCurrency(d?.claimSettled)}`,
    claimsOutstanding: `₹ ${convertToLocalCurrency(d?.claimsOutstanding)}`,
    claimsRatio: `${d?.claimsRatio}`,
    numberOfEmployees: `${d?.numberOfEmployees}`,
    numberOfLives: `${d?.numberOfLives}`,
    parentsIncluded: `${d?.parentsIncluded}`,
    premiumPaid: `₹ ${convertToLocalCurrency(d?.premiumPaid)}`,
    year: `${convertToLocalCurrency(d?.year)}`,
  }))

  const rowsDecision = (text) => {
    if (text === INSURANCE?.MARINE) {
      return rowsMarine
    } else if (text === INSURANCE?.HEALTH) {
      return rowsHealth
    } else {
      return rows
    }
  }
  const columnsDecision = (text) => {
    if (text === INSURANCE?.MARINE) {
      return columnsMarine
    } else if (text === INSURANCE?.HEALTH) {
      return columnsHealth
    } else {
      return columns
    }
  }
  return (
    <>
      <div className={classes.root}>
        <div className={classes.title}>
          {!isFinancialView ? (
            <span>
              {yearsText} {totalData?.length} Years
            </span>
          ) : (
            <span>
              {financialYearsText} {totalData?.length} Years
            </span>
          )}
          <CloseButton
            classname={classes.closeBtn}
            title='Close'
            handleClose={closefunction}
          />
        </div>
        <DataGrid
          rows={rowsDecision(type)}
          columns={columnsDecision(type)}
          disableColumnMenu
          disableColumnSelector
          pageSize={8}
          density='compact'
          isRowSelectable={() => false}
          getCellClassName={() => classes.tableCell}
        />
      </div>
    </>
  )
}

export default DetailedView

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: MODAL_HEIGHT,
    padding: '24px',
    boxSizing: 'border-box',
    position: 'relative',
  },
  tableCell: {
    paddingLeft: '15px !important',
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
  },
  title: {
    fontSize: '22px',
    padding: '0px 100px 10px 0px',
    margin: '0 0 10px 0px',
    position: 'relative',
    textAlign: 'left',
  },
})
